<template>
  <div class="auth-doc">
    <!-- 文书标题 -->
    <header class="doc-header">
      <h1 class="doc-title">信息核验授权书</h1>
    </header>

    <!-- 重要提示 -->
    <section class="doc-notice">
      <div class="notice-title">重要提示</div>
      <p class="notice-text">
        请您仔细阅读本授权书的全部内容（尤其是带有
        <em class="mark">▲▲</em> 标记和字体加粗的内容）。如您对本授权书内容（包括但不限于带有
        <em class="mark">▲▲</em> 标记和字体加粗的内容）有任何疑问或希望进一步理解相关条款内容的具体含义，请务必在签署前提请服务商予以说明，服务商将向您解释说明相关条款含义及后果。如果服务商尚未向您解释说明相关条款含义及后果，或您对本授权书的任何内容仍有疑问，请您不要进行后续操作。
      </p>
      <p class="notice-text">
        请您在仔细阅读本授权书涉及的个人信息处理目的、处理的个人信息种类、个人信息处理方式、个人信息交互模式等内容后，在您所涉及的内容/条款前的"<span class="circle">○</span>"勾选框中进行勾选（在
        <span class="circle checked">○</span> 内打"<span class="tick">√</span>"表示适用，在
        <span class="circle">○</span> 内未作任何标记表示不适用）并签署本授权书。勾选相应"<span class="circle">○</span>"勾选框并签署意味着您对勾选事项的确认和单独同意，表示对于您提请服务商说明的相关事项，银行已应您的要求对相关条款内容的含义及后果作了说明，您勾选相应"<span class="circle">○</span>"勾选框并签署本授权书时对所有内容无疑问，对于相关条款内容的含义、接受相关约定后所需承担的责任、后果等均已理解，您已同意授权书的全部内容，愿意按照授权书约定履行责任。
      </p>
      <p class="notice-text">
        如您未授权服务商处理相应业务或服务项下所必需的个人信息或撤回授权同意的，您无法使用本授权书所述相应业务或服务。
      </p>
      <p class="notice-addressee">
        海礼网（北京）智能技术有限公司（被授权人，以下简称"服务商"）：
      </p>
    </section>

    <!-- 正文条款 -->
    <section class="doc-body">
      <h2 class="clause-title">一、处理目的</h2>
      <p class="clause-text">
        鉴于服务商在客户使用买单吧 APP 免息商城购物下单时需要对客户填写的寄送人信息进行物流配送（以下简称"处理目的"），现本人（授权人，以下简称"本人"）同意服务商根据本授权书的约定对本人寄送信息进行处理（包括但不限于收集、存储、使用、传输、提供、共享、删除等，下同）。
      </p>

      <h2 class="clause-title"><em class="mark">▲▲</em>二、处理的个人信息种类</h2>
      <p class="clause-text">
        本人知悉并同意，服务商处理的个人信息包括：寄送人姓名、寄送人号码和寄送人配送地址。
      </p>

      <h2 class="clause-title"><em class="mark">▲▲</em>三、个人信息处理方式</h2>
      <p class="clause-text">
        本人知悉并同意，本授权书生效后，银行有权将相关个人信息作如下处理：
      </p>
      <p class="clause-text">
        （一）本人使用买单吧 APP 免息商城购物下单时填写的寄送人信息时，服务商需对本人使用买单吧 APP 免息商城购物下单时填写的寄送人信息进行物流配送，服务商将收集本人寄送信息，并将收集到的本人寄送信息，传递至与服务商有合作关系的交通银行太平洋信用卡中心及物流公司，交通银行太平洋信用卡中心用于售后服务及商户管理，物流公司用于进行货物配送。物流公司接收本人前述个人寄送信息后将配送物流单号直接传递至服务商。
      </p>
      <p class="clause-text">
        （二）服务商有权自收集相应的个人信息之时起，至本人注销银行账户后另加 10 年（以下简称"保存期限"）内保存、在交通银行股份有限公司总行及其所属分支机构（以下简称"交通银行机构"）之间相互传递本授权书和依据本授权书处理的个人信息，且基于前述传递，接收该等授权书和个人信息的交通银行机构有权按本授权书约定处理接收的个人信息。
      </p>
      <p class="clause-text">（三）服务商不得公开其处理的个人信息，本人另行书面同意除外。</p>
      <p class="clause-text">
        （四）委托处理个人信息。本人知悉并同意，服务商有权在本授权书约定处理目的和范围内，委托第三方处理个人信息。服务商将与第三方就委托处理个人信息的目的、期限、处理方式等进行约定，并对第三方的个人信息处理活动进行监督。
      </p>

      <h2 class="clause-title"><em class="mark">▲▲</em>四、个人信息交互模式</h2>
      <h3 class="clause-subtitle"><em class="mark">▲▲</em>向其他个人信息处理者提供个人信息</h3>
      <p class="clause-text">
        本人知悉并同意，服务商有权将本人寄送信息传递至法律法规允许或政府机关授权的其他个人信息处理者（以下简称"信息接收方"）。信息接收方应当在本条下述信息接收方的处理目的、处理方式和个人信息种类范围内处理接收的个人信息，如信息接收方变更处理目的、处理方式的，信息接收方应当依照法律规定重新取得本人同意。本业务项下，服务商将本人个人信息传输至物流公司。若本人使用买单吧 APP 免息商城购物下单时填写的寄送人信息时，服务商需对本人使用买单吧 APP 免息商城购物下单时填写的寄送人信息进行物流配送，服务商将收集本人寄送信息，并将收集到的本人寄送信息，传递至与服务商有合作关系的交通银行太平洋信用卡中心及物流公司，交通银行太平洋信用卡中心用于售后服务及商户管理，物流公司用于进行货物配送。物流公司接收本人前述个人寄送信息后将配送物流单号直接传递至服务商。
      </p>

      <h2 class="clause-title"><em class="mark">▲▲</em>五、处理敏感个人信息的必要性和对个人权益的影响</h2>
      <p class="clause-text">
        本人知悉并同意，服务商依据本授权书处理的寄送信息中涉及敏感寄送信息，敏感寄送信息一旦泄露或者非法使用，容易导致自然人的人格尊严受到侵害或者人身、财产安全受到危害。如果本人不提供或者不同意服务商处理敏感寄送信息，本人将无法使用本授权书所述相应产品或者服务。
      </p>

      <h2 class="clause-title"><em class="mark">▲▲</em>六、信息安全及保密</h2>
      <p class="clause-text">
        本人知悉并同意，服务商将采取必要措施保障所处理的寄送信息的安全。服务商及其涉及处理寄送信息的员工应当对服务商处理的寄送信息严格保密，不得非法收集、使用、加工、传输、买卖、提供或公开寄送信息，并应严格按照本授权书约定和相关法律法规处理寄送信息。如服务商及其涉及处理寄送信息的员工超出本授权书约定的范围违法处理寄送信息，服务商应承担相应的法律责任。互联网环境并非百分之百安全，服务商不对由此产生或与之相关的任何风险、损失承担责任。如发生寄送信息安全事件，服务商将按照法律法规的要求及时向本人进行告知并按照监管部门要求报告个人信息安全事件的处置情况。
      </p>

      <h2 class="clause-title"><em class="mark">▲▲</em>七、授权同意的例外情形</h2>
      <p class="clause-text">
        本人知悉并同意，根据相关法律规定，符合以下任一情形的，服务商处理本人寄送信息无需征得本人的授权同意：
      </p>
      <p class="clause-text">（一）为订立、履行本人作为一方当事人的合同所必需，或者按照依法制定的劳动规章制度和依法签订的集体合同实施人力资源管理所必需；</p>
      <p class="clause-text">（二）为履行法定职责或者法定义务所必需；</p>
      <p class="clause-text">（三）为应对突发公共卫生事件，或者紧急情况下为保护自然人的生命健康和财产安全所必需；</p>
      <p class="clause-text">（四）为公共利益实施新闻报道、舆论监督等行为，在合理的范围内处理寄送信息；</p>
      <p class="clause-text">（五）依照法律规定在合理的范围内处理本人自行公开或者其他已经合法公开的寄送信息；</p>
      <p class="clause-text">（六）法律、行政法规规定的其他情形。</p>

      <h2 class="clause-title">八、个人行使权利的方式</h2>
      <p class="clause-text">
        （一）基于本人同意处理个人信息的，本人有权撤回对本授权书所述任一、部分或全部寄送信息处理的授权同意。本人撤回授权同意的，不影响撤回前服务商基于本人同意已经进行的寄送信息处理活动的效力。本人知悉并同意，如撤回授权同意对本授权书所述业务或服务产生影响的，本人需要提前终止相关业务或服务后方可撤回授权同意，撤回授权同意后，本人将无法使用本授权书所述业务或服务。
      </p>
      <p class="clause-text">（二）本人有权限制或拒绝服务商处理个人信息，亦有权注销账号。</p>
      <p class="clause-text">
        （三）本人有权向服务商查阅、复制本人/被代理人寄送信息，法律、行政法规规定应当保密或者不需要告知的除外。本人发现本人/被代理人寄送信息不准确或者不完整的，有权请求服务商更正、补充。如本人请求将寄送信息转移至本人指定的公司、组织或个人的，在符合国家网信部门和行业监管规定条件的前提下，服务商会向本人提供信息转移的途径。
      </p>
      <p class="clause-text">（四）有下列情形之一的，服务商应当主动删除寄送信息。服务商未删除的，本人有权请求服务商删除：</p>
      <p class="clause-text sub-indent">1. 处理目的已实现、无法实现或者为实现处理目的不再必要；</p>
      <p class="clause-text sub-indent">2. 服务商停止提供产品或者服务，或者保存期限已届满；</p>
      <p class="clause-text sub-indent">3. 基于本人同意处理寄送信息的，本人撤回授权同意；</p>
      <p class="clause-text sub-indent">4. 服务商违反法律、行政法规或者违反约定处理寄送信息；</p>
      <p class="clause-text sub-indent">5. 法律、行政法规规定的其他情形。</p>
      <p class="clause-text">
        法律、行政法规规定的保存期限未届满，或者删除寄送信息从技术上难以实现的，服务商应当停止除存储和采取必要的安全保护措施之外的处理。
      </p>
      <p class="clause-text">（五）本人有权要求银行对其寄送信息处理规则进行解释说明。</p>
      <p class="clause-text">
        （六）本人可通过致电服务商客服服务热线 400-677-7159 行使上述权利。为保障安全，服务商可能会先要求验证本人身份，再处理本人的请求。本人可能需要提供书面请求，或者以其他方式证明本人的身份。如您对服务商寄送信息处理或对您行使法律法规规定权利的方式和程序有任何疑问、意见、投诉建议，可通过拨打服务商客服服务热线 400-677-7159 进行咨询、反映。
      </p>

      <h2 class="clause-title">九、授权书的生效、变更和终止</h2>
      <p class="clause-text highlight">
        <em class="mark">▲▲</em>（一）本授权书签署后生效。线下签署本授权书的，"签署"是指本人在本授权书上签名。线上签署本授权书的，"签署"是指本人在对应业务渠道相应页面按提示说明文字完成相应操作。
      </p>
      <p class="clause-text highlight">
        <em class="mark">▲▲</em>（二）服务商有权根据法律法规变化对授权书内容进行修改，修改后的授权书将通过买单吧 APP - 免息商城 - 海尔精选商城渠道发布由本人使用免息商城购物下单时填写的寄送人信息时签署修改后的授权书。服务商未收到本人签署的修改后的授权书前，仍按本人签署的原授权书执行。
      </p>
      <p class="clause-text">（三）除本授权书期限与保存期限一致外，本授权书终止不代表保存期限届满。</p>
    </section>

    <!-- 签署确认声明 -->
    <section class="doc-statement">
      <p>
        本人已通读授权书全部条款内容（尤其是带有
        <em class="mark">▲▲</em> 标记和字体加粗的条款内容）。对于存有疑问的条款内容，本人已提请银行作了说明，本人签署本授权书即表明服务商已应本人的要求对相关条款含义及后果作了说明，本人签署本授权书时对所有内容无疑问，对于相关条款的含义、接受相关约定后所需承担的责任、后果等均已理解，本人已同意授权书的全部条款内容（尤其是带有
        <em class="mark">▲▲</em> 标记和字体加粗的内容），愿意按照本授权书约定履行责任。
      </p>
    </section>

    <!-- 关键条款勾选确认区 -->
    <section class="doc-confirm">
      <div class="confirm-divider">
        <span class="divider-text">信息核验授权书</span>
      </div>
      <p class="confirm-tip">
        请确认您已知晓授权协议中"处理的个人信息种类"和"向其他个人信息处理者提供寄送信息"条款内容。
      </p>
      <p class="confirm-tip">如您同意下述两则条款请点击"○"勾选，否则请不要操作。</p>

      <div
        class="confirm-item"
        :class="{ checked: checked.kind }"
        @click="toggle('kind')"
      >
        <span class="check-circle">{{ checked.kind ? '√' : '' }}</span>
        <div class="confirm-body">
          <div class="confirm-title">处理的个人信息种类</div>
          <p class="confirm-text">
            本人知悉并同意，服务商处理的个人信息包括：寄送人姓名、寄送人号码和寄送人配送地址。
          </p>
        </div>
      </div>

      <div
        class="confirm-item"
        :class="{ checked: checked.share }"
        @click="toggle('share')"
      >
        <span class="check-circle">{{ checked.share ? '√' : '' }}</span>
        <div class="confirm-body">
          <div class="confirm-title">向其他个人信息处理者提供寄送信息</div>
          <p class="confirm-text">
            本人知悉并同意，服务商有权将本人填写寄送人姓名、寄送人号码和寄送人配送地址信息传递至法律法规允许或政府机关授权的其他个人信息处理者（以下简称"信息接收方"）。信息接收方应当在本条下述信息接收方的处理目的、处理方式和个人信息种类范围内处理接收的寄送信息，如信息接收方变更处理目的、处理方式的，信息接收方应当依照法律规定重新取得本人同意。本业务项下，服务商将本人个人信息传递至与服务商有合作关系的交通银行太平洋信用卡中心及物流公司，交通银行太平洋信用卡中心用于售后服务及商户管理，物流公司用于进行货物配送。物流公司接收本人前述个人寄送信息后将配送物流单号直接传递至服务商。
          </p>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "InformationVerification",
  data() {
    return {
      checked: {
        kind: false,
        share: false
      }
    };
  },
  methods: {
    toggle(key) {
      this.checked[key] = !this.checked[key];
    }
  }
};
</script>

<style scoped lang="scss">
.auth-doc {
  min-height: 100vh;
  padding: 0.3rem 0.3rem 0.6rem;
  background: #f5f5f5;
  font-family: -apple-system, "PingFang SC", "Microsoft YaHei", sans-serif;
  color: #333;
  font-size: 0.28rem;
  line-height: 1.7;
}

/* 标题 */
.doc-header {
  text-align: center;
  padding: 0.2rem 0 0.3rem;

  .doc-title {
    font-size: 0.42rem;
    font-weight: bold;
    color: #1a1a1a;
    letter-spacing: 0.04rem;
  }
}

/* 重要提示 */
.doc-notice {
  background: #fff;
  border-radius: 0.12rem;
  padding: 0.24rem 0.28rem;
  margin-bottom: 0.24rem;

  .notice-title {
    font-size: 0.3rem;
    font-weight: bold;
    color: #c0392b;
    margin-bottom: 0.12rem;
  }

  .notice-text {
    text-indent: 2em;
    margin-bottom: 0.16rem;
    color: #444;

    &:last-of-type {
      margin-bottom: 0;
    }
  }

  .notice-addressee {
    margin-top: 0.2rem;
    font-weight: bold;
    color: #222;
  }
}

/* 正文 */
.doc-body {
  background: #fff;
  border-radius: 0.12rem;
  padding: 0.24rem 0.28rem;
  margin-bottom: 0.24rem;

  .clause-title {
    font-size: 0.3rem;
    font-weight: bold;
    color: #1a1a1a;
    margin-top: 0.28rem;
    margin-bottom: 0.12rem;
    padding-bottom: 0.08rem;
    border-bottom: 0.02rem solid #eee;

    &:first-child {
      margin-top: 0;
    }
  }

  .clause-subtitle {
    font-size: 0.28rem;
    font-weight: bold;
    color: #333;
    margin: 0.2rem 0 0.1rem;
  }

  .clause-text {
    text-indent: 2em;
    margin-bottom: 0.14rem;
    color: #333;

    &.sub-indent {
      text-indent: 3em;
      margin-bottom: 0.08rem;
    }

    &.highlight {
      background: #fff8e6;
      border-left: 0.06rem solid #f0a500;
      padding: 0.12rem 0.16rem;
      border-radius: 0 0.08rem 0.08rem 0;
      margin-left: -0.12rem;
    }
  }
}

/* 强调标记 ▲▲ */
.mark {
  color: #c0392b;
  font-weight: bold;
  font-style: normal;
  margin-right: 0.06rem;
}

/* 行内圆圈示意（提示文字中） */
.circle {
  display: inline-block;
  width: 0.32rem;
  height: 0.32rem;
  line-height: 0.3rem;
  text-align: center;
  border: 0.02rem solid #999;
  border-radius: 50%;
  font-size: 0.22rem;
  margin: 0 0.02rem;
  vertical-align: middle;

  &.checked {
    border-color: #c0392b;
    color: #c0392b;
    font-weight: bold;
  }
}

.tick {
  color: #c0392b;
  font-weight: bold;
}

/* 签署确认声明 */
.doc-statement {
  background: #fff;
  border-radius: 0.12rem;
  padding: 0.24rem 0.28rem;
  margin-bottom: 0.24rem;

  p {
    text-indent: 2em;
    color: #444;
  }
}

/* 勾选确认区 */
.doc-confirm {
  background: #fff;
  border-radius: 0.12rem;
  padding: 0.24rem 0.28rem 0.36rem;

  .confirm-divider {
    text-align: center;
    margin: 0.04rem 0 0.2rem;
    position: relative;

    &::before {
      content: "";
      position: absolute;
      left: 0;
      right: 0;
      top: 50%;
      height: 0.02rem;
      background: #eee;
    }

    .divider-text {
      position: relative;
      display: inline-block;
      padding: 0 0.2rem;
      background: #fff;
      font-size: 0.3rem;
      font-weight: bold;
      color: #1a1a1a;
    }
  }

  .confirm-tip {
    text-indent: 2em;
    color: #444;
    margin-bottom: 0.12rem;
  }

  .confirm-item {
    display: flex;
    align-items: flex-start;
    padding: 0.2rem;
    margin-top: 0.2rem;
    background: #fafafa;
    border: 0.02rem solid #e8e8e8;
    border-radius: 0.1rem;
    transition: all 0.2s;

    &.checked {
      background: #fff7f5;
      border-color: #c0392b;
    }

    .check-circle {
      flex-shrink: 0;
      width: 0.4rem;
      height: 0.4rem;
      line-height: 0.36rem;
      text-align: center;
      border: 0.04rem solid #bbb;
      border-radius: 50%;
      color: #fff;
      font-size: 0.28rem;
      font-weight: bold;
      margin-right: 0.2rem;
      margin-top: 0.02rem;
      transition: all 0.2s;
    }

    &.checked .check-circle {
      border-color: #c0392b;
      background: #c0392b;
    }

    .confirm-body {
      flex: 1;
      min-width: 0;
    }

    .confirm-title {
      font-size: 0.3rem;
      font-weight: bold;
      color: #1a1a1a;
      margin-bottom: 0.08rem;
    }

    .confirm-text {
      color: #444;
      text-indent: 2em;
    }
  }
}
</style>
